export const CONNECT_SKVLLBABIEZ = 'CONNECT_SKVLLBABIEZ';
export const UPDATE_SKVLLBABIEZ_LIST = 'UPDATE_SKVLLBABIEZ_LIST';
export const DECREMENT_SKVLLBABIEZ = 'DECREMENT_SKVLLBABIEZ';
export const SET_MINTING_STATE = 'SET_MINTING_STATE';
export const RESET_SKVLLBABIEZ_STATE = 'RESET_SKVLLBABIEZ_STATE';
